import { useEffect } from "react";
import { useLocation } from "react-router";

const BASE_TITLE = "Istari Digital";

export function formatPageTitle(title: string): string {
  return title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
}

export function usePageTitle(title: string): void {
  const location = useLocation();
  useEffect(() => {
    document.title = formatPageTitle(title);
  }, [location.pathname, title]);
}

export function PageTitle({ title }: { title: string }) {
  usePageTitle(title);
  return null;
}
